export const ensureHtmlWrapped = (input) => {
    if (!input || typeof input !== 'string')
        return '<p></p>';
    const trimmed = input.trim();
    const htmlTagRegex = /^<([a-zA-Z]+)(\s[^>]*)?>[\s\S]*<\/\1>$/;
    if (htmlTagRegex.test(trimmed)) {
        return trimmed;
    }
    return `<p>${trimmed}</p>`;
};
